import { createContext, type ReactNode } from "react";

export interface ToolbarMenuSection {
  content: ReactNode;
  disabled: boolean;
  /** Layout, filters, and sorting share a single View tab. */
  isView: boolean;
}

/**
 * How the More menu presents its sections:
 * - `"page"` — one titled page listing every enabled section's content, one after another.
 * - `"tabs"` — a horizontal band of option pills, each revealing only its own section.
 */
export type ToolbarMenuLayout = "page" | "tabs";

/** Option pills join their enclosing More menu instead of opening another modal. */
export const ToolbarMenuContext = createContext<{
  activeId: string | undefined;
  close: () => void;
  isOpen: boolean;
  layout: ToolbarMenuLayout;
  register: (id: string, section: ToolbarMenuSection) => void;
  select: (id: string) => void;
  unregister: (id: string) => void;
  viewId: string | undefined;
} | null>(null);
